import { Injectable } from '@angular/core';
import { ApiHttpService, ApiService } from '@capturum/api';
import { Observable } from 'rxjs';
import { Report, ReportList } from '@core/models/report.model';
import { MapItem } from '@capturum/auth';
import { responseData } from '@capturum/builders/core';

@Injectable({
  providedIn: 'root',
})
export class ReportService extends ApiService<Report> {
  protected endpoint = 'report';

  constructor(public apiHttp: ApiHttpService) {
    super(apiHttp);
  }

  public rejectReport(reportId: string, remark: string): Observable<Report> {
    return this.apiHttp.post(`/${this.endpoint}/${reportId}/reject`, { remark });
  }

  public getReportList(): Observable<ReportList> {
    return this.apiHttp.get(`/${this.endpoint}/list`);
  }

  public getPowerBiReportList(): Observable<MapItem[]> {
    return this.apiHttp.get(`/power-bi-report/list`).pipe(responseData);
  }
}
